import {useCallback} from 'react';
import {getIsAgeRestricted} from '../../../../common/getIsAgeRestricted';
import {PosterViewItem} from '../../../../design-system/organisms/PosterViewItem/PosterViewItem';
import {
  GroupType,
  HelixThemeSection,
  PosterViewItem as PosterViewItemType,
  SectionType,
} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_SERIES_CLICK} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonItemProps} from '../../type';

export function PosterView({
  item,
  parentGroup,
  parentSection,
}: CommonItemProps) {
  const {
    title,
    altText,
    thumbnail,
    badgeList,
    statusBadge,
    ageGradeBadge,
    subtitleList,
    scheme,
    ageGrade,
    selfCensorship,
    showPlayerIcon,
    eventLog,
    rank,
    rankVariation,
    discountRateText,
  } = item as PosterViewItemType;
  const {user} = useLogin();

  const section = parentSection as Omit<HelixThemeSection, 'groups'>;
  const isRecommendArea = section.isRecommendArea;
  const isHelixThemeSection = section.type === SectionType.HelixTheme;

  const inViewCallback = useCallback(
    (target: Element | undefined) => {
      if (!isHelixThemeSection) {
        return;
      }
      aggregateAndSendLog({
        targetElem: target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '작품_노출',
        customProps: {
          user_action: 'imp',
        },
        ...(isHelixThemeSection && {
          viewimp_contents: {
            name: title,
            type: 'seriesId',
          },
        }),
      });
    },
    [isHelixThemeSection, title]
  );

  return (
    <PosterViewItem
      {...putTiaraObjectProps(eventLog)}
      onInView={
        isRecommendArea
          ? target => {
              inViewCallback(target);
            }
          : undefined
      }
      onClickCapture={LOG_SERIES_CLICK}
      title={title || ''}
      altText={altText || ''}
      posterSrc={thumbnail}
      badgeList={badgeList}
      statusBadge={statusBadge}
      subtitleList={subtitleList}
      ageGradeBadge={ageGradeBadge}
      discountRateText={discountRateText}
      isAgeRestricted={getIsAgeRestricted({
        age: user?.age,
        authenticatedAt: user?.authenticatedAt,
        ageGrade,
        selfCensorship,
      })}
      scheme={scheme}
      showPlayerIcon={showPlayerIcon}
      imageLazyLoad={false}
      className={
        parentGroup.type === GroupType.HorizontalScroll ? 'w-98pxr' : ''
      }
      rank={rank}
      rankVariation={rankVariation}
    />
  );
}
